"use strict";
var r, e;
function a() {
  return e || (e = 1, r = EvalError), r;
}
export {
  a as __require
};
//# sourceMappingURL=index.es305.js.map
